import { Outlet, NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Building2,
  Megaphone,
  LogOut,
  Shield,
  CreditCard,
  UserPlus,
} from 'lucide-react';
import { cn } from '@/lib/utils';

const navItems = [
  { to: '/super-admin/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/super-admin/tenants', label: 'Estabelecimentos', icon: Building2 },
  { to: '/super-admin/requests', label: 'Solicitações', icon: UserPlus },
  { to: '/super-admin/plans', label: 'Planos', icon: CreditCard },
  { to: '/super-admin/announcements', label: 'Comunicados', icon: Megaphone },
];

export function SuperAdminLayout() {
  return (
    <div className="flex h-screen" style={{ background: '#0f172a' }}>
      {/* Sidebar com tema escuro fixo (não herda do tenant) */}
      <aside className="flex w-64 flex-col border-r" style={{ borderColor: '#1e293b', background: '#1e293b' }}>
        <div className="flex h-16 items-center gap-3 border-b px-5" style={{ borderColor: '#334155' }}>
          <div className="flex h-9 w-9 items-center justify-center rounded-lg" style={{ background: '#10b981' }}>
            <Shield className="h-5 w-5 text-white" />
          </div>
          <div>
            <span className="text-base font-bold text-white">FluxoPDV</span>
            <p className="text-xs" style={{ color: '#94a3b8' }}>Painel Administrativo</p>
          </div>
        </div>
        <nav className="flex-1 space-y-1 p-3">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-3 rounded-lg px-3 py-2.5 text-base font-medium transition-colors',
                  isActive
                    ? 'text-white'
                    : 'hover:text-white'
                )
              }
              style={({ isActive }) => ({
                background: isActive ? '#10b981' : 'transparent',
                color: isActive ? '#fff' : '#94a3b8',
              })}
            >
              <item.icon className="h-5 w-5" />
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t p-3" style={{ borderColor: '#334155' }}>
          <button
            className="flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-base font-medium transition-colors hover:bg-red-500/10"
            style={{ color: '#94a3b8' }}
            onClick={() => {
              localStorage.removeItem('superAdminToken');
              localStorage.removeItem('superAdminRefreshToken');
              localStorage.removeItem('superAdminUser');
              window.location.href = '/super-admin/login';
            }}
          >
            <LogOut className="h-5 w-5" />
            Sair
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto" style={{ background: '#0f172a', color: '#e2e8f0' }}>
        <Outlet />
      </main>
    </div>
  );
}
